import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDSmL7Jk3WyHuLUZPkUGcr63osJWJi0JCc",
  authDomain: "medical-4c6de.firebaseapp.com",
  projectId: "medical-4c6de",
  storageBucket: "medical-4c6de.firebasestorage.app",
  messagingSenderId: "1015909434004",
  appId: "1:1015909434004:web:a2253539212c546e1f6a81",
  measurementId: "G-14WNS3BE4T"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export default app;
